/**
 * Red Bud Configurator - Geometric Tolerances and Physical Dimensions Registry
 * Consolidates all math constants, snapping thresholds, and precision epsilons.
 */

export const GEOMETRY_TOLERANCES = {
  // Trigonometric & collinear floating-point tolerance (1 mm)
  CALCULATION_EPSILON: 0.001,

  // Spatial point snapping and overlap tolerance (1 cm)
  POINT_SNAP_EPSILON: 0.01,

  // Proximity threshold for module-to-module docking (5 cm)
  DOCKING_TOLERANCE: 0.05,

  // Minimum physical length for a wall segment to be rendered / preserved (10 cm)
  MIN_WALL_LENGTH_M: 0.1,

  // Default placement ratio along a segment (50% = center)
  DEFAULT_SEGMENT_POSITION: 0.5,

  // Coincident segment detection margin (1 cm)
  COINCIDENT_MARGIN_M: 0.01,
};

/**
 * Unit conversion utilities between real-world meters and canvas pixels
 */
export const UNIT_CONVERSIONS = {
  metersToPixels: (meters, ppm = 50) => meters * ppm,
  pixelsToMeters: (pixels, ppm = 50) => pixels / ppm,
  roundToMm: (meters) => Math.round(meters * 1000) / 1000,
  roundToCm: (meters) => Math.round(meters * 100) / 100,
};

export default GEOMETRY_TOLERANCES;
